<template>
	<vs-list v-if="list.length > 0">
		<draggable :list="list">
			<transition-group>
				<vs-list-item class="list-item" v-for="(listItem, index) in list" :key="index">
					<vs-avatar
						slot="avatar"
						:text="jobTypeTranslate(listItem.job_type)"
						@click="action('select', index)"
					/>

					<template slot="title">
						<div @click="action('select', index)" class="ml-2">
							<p>{{ jobTypeTranslate(listItem.job_type) }}</p>
							<span class="text-sm">
								{{ listItem.service_time }}
							</span>
						</div>
					</template>

					<feather-icon
						icon="EditIcon"
						svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
						@click.stop="action('edit', index)"
						class="mr-4"
					/>

					<feather-icon
						icon="Trash2Icon"
						svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
						@click.stop="action('delete', index)"
					/>
				</vs-list-item>
			</transition-group>
		</draggable>
	</vs-list>
</template>
<script>
import draggable from "vuedraggable";

export default {
	props: {
		waypoints: {
			type: Array,
			required: true,
		},
		action: {
			type: Function,
			required: false,
		},
	},
	data() {
		return {
			list: this.waypoints,
			listSize: this.waypoints.length,
		};
	},
	computed: {
		jobTypeTranslate() {
			return function (jobType = "PICKUP") {
				return jobType === "PICKUP"
					? this.$t("Waypoint.Pickup").toUpperCase()
					: this.$t("Waypoint.Delivery").toUpperCase();
			};
		},
	},
	components: {
		draggable,
	},
	watch: {
		list(value) {
			// dispatch the action to reorder the waypoints if the list length is changed
			if (value.length === this.listSize) {
				this.action("reorder", value);
			}
			this.listSize = value.length;
		},
	},
};
</script>
<style>
.list-item {
	transition: all 1s;
}
</style>
